exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bold {\n  font-weight: bold; }\n\n.italic {\n  font-style: italic; }\n\n.underline {\n  text-decoration: underline; }\n\n.code {\n  color: #333;\n  background: #eee; }\n", ""]);

